var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import Typography from '../../Styles/Typography/Typography';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import Spinner from '../../Progress/Spinner/Spinner';
import Icon from '../../Styles/Icons/Icon';
import Box from '../../Layout/Flex/Box';
import DoneImage from '../../img/button/done_icon.svg';
import ErrorImage from '../../img/button/error_icon.svg';
import { ButtonStyle, ActionResultContainer } from '../buttonsCommonStyles';
const ButtonBox = styled.div `
  line-height: ${props => props.theme.fonts.lineHeight};
  width: ${(props) => (props.block ? '100%' : 'fit-content')};
  overflow: hidden;
  display: ${(props) => props.hideIf ? 'none' : props.block ? 'flex' : 'inline-flex'};
  flex-direction: ${(props) => props.isError || props.isDone ? 'column' : 'row'};
  box-sizing: border-box;
`;
const Button = (_a) => {
    var { text = 'Button', errorText = 'Error', doneText = 'Done', color = 'main', language, onClick, isError = false, isLoadingSpinner = false, isLoading = false, isDone = false, isDisabled = false, secondary = false, noBorder = false, isFull = false, isBlock = false, noMargin = false, size = 'button', textWeight = 'normal', hideIf = false, textAlign = 'left', textWrap = 'anywhere', mediaQuery, typographyMediaQuery, icon = { position: '', icon: '' } } = _a, props = __rest(_a, ["text", "errorText", "doneText", "color", "language", "onClick", "isError", "isLoadingSpinner", "isLoading", "isDone", "isDisabled", "secondary", "noBorder", "isFull", "isBlock", "noMargin", "size", "textWeight", "hideIf", "textAlign", "textWrap", "mediaQuery", "typographyMediaQuery", "icon"]);
    const [buttonDimensions, setButtonDimensions] = useState({ height: 0, width: 0 });
    const buttonClass = `button-style-${text.replaceAll(' ', '')}`;
    const theme = useTheme();
    useEffect(() => {
        const getButtonWidth = () => {
            const element = document.getElementsByClassName(buttonClass)[0];
            if (element) {
                setButtonDimensions({
                    height: element.clientHeight,
                    width: element.clientWidth
                });
            }
            else {
                setButtonDimensions({
                    height: 35,
                    width: 150
                });
            }
        };
        if (buttonClass)
            getButtonWidth();
    }, [buttonClass]);
    return isLoadingSpinner
        ? (secondary
            ? (_jsx(Spinner, { marginSM: !noMargin, secondary: true }))
            : (_jsx(Spinner, { marginSM: !noMargin })))
        : _jsx(ButtonBox, Object.assign({ hideIf: hideIf, isError: isError, isDone: isDone, block: isBlock }, props, { children: isLoading
                ? _jsx(Skeleton, { height: `${buttonDimensions.height}px`, width: isBlock ? '100%' : `${buttonDimensions.width}px`, margin: noMargin ? '0px' : theme.paddingsMargins.themeMenuMargin, style: {
                        padding: theme.paddingsMargins.minPadding,
                        paddingLeft: theme.paddingsMargins.themeMenuPaddingSingle,
                        paddingRight: theme.paddingsMargins.themeMenuPaddingSingle
                    } })
                : _jsxs(_Fragment, { children: [_jsx(ButtonStyle, Object.assign({ className: buttonClass, isDisabled: isDisabled, onClick: isDisabled ? () => { } : onClick, noBorder: noBorder, secondary: secondary, isFull: isFull, isBlock: isBlock, noMargin: noMargin, color: color, mediaQuery: mediaQuery }, { children: _jsxs(Box, { children: [icon.position === 'left' && _jsx(Icon, { size: size, icon: icon.icon, noMargin: true, style: { marginRight: theme.paddingsMargins.themeMenuMarginSingle }, color: isDisabled || isFull ? 'white' : secondary ? 'secondary' : color }), _jsx(Typography, Object.assign({ style: { width: isBlock ? '100%' : 'auto' }, overflowWrap: textWrap, color: isDisabled || isFull ? 'white' : secondary ? 'secondary' : color, align: textAlign, weight: textWeight, size: size, mediaQuery: typographyMediaQuery }, { children: text })), icon.position === 'right' && _jsx(Icon, { size: size, icon: icon.icon, noMargin: true, style: { marginLeft: theme.paddingsMargins.themeMenuMarginSingle }, color: isDisabled || isFull ? 'white' : secondary ? 'secondary' : color })] }) })), (isError || isDone) && (_jsxs(ActionResultContainer, Object.assign({ noMargin: noMargin }, { children: [_jsx("img", { style: {
                                        height: 'auto',
                                        width: '15px'
                                    }, src: isError ? ErrorImage : DoneImage, alt: isError ? 'error' : 'done' }), _jsx(Typography, Object.assign({ color: isError ? 'error' : 'done', size: "note" }, { children: isError ? errorText : doneText }))] })))] }) }));
};
export default Button;
